(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/payment/assets/create-payment.js') >= 0) return;  svs.modules.push('/components/payment/payment/assets/create-payment.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$components$payme = svs.components.payment.common.utils,
  pipeline = _svs$components$payme.pipeline,
  subject = _svs$components$payme.subject;
const _svs$components$payme2 = svs.components.payment.common.error,
  CollectionError = _svs$components$payme2.CollectionError,
  PaymentError = _svs$components$payme2.PaymentError;
const PaymentService = svs.components.payment.servicePayment.PaymentService;
const logger = svs.components.payment.common.logger;
const _svs$components$payme3 = svs.components.payment.payment.context,
  createPaymentContextApi = _svs$components$payme3.createPaymentContextApi,
  createMiddlewareContextApi = _svs$components$payme3.createMiddlewareContextApi,
  createPaymentResponseApi = _svs$components$payme3.createPaymentResponseApi;

const createPayment = paymentService => {
  if (!(paymentService instanceof PaymentService)) {
    throw new Error('PaymentService is required');
  }
  const payableItems = [];
  const obj = {};
  const observers = {};
  const preMiddlewares = pipeline();
  const postMiddlewares = pipeline();

  let proxyObj;
  let isPendingPayment = false;
  let isPaymentInitializedOnce = false;

  ['onStart', 'onFinally'].forEach(method => {
    observers[method] = subject();
    obj[method] = observer => {
      observers[method].subscribe(observer);
      return proxyObj;
    };
  });

  const tryPay = async userContext => {
    const _createMiddlewareCont = createMiddlewareContextApi(payableItems, observers, userContext),
      _createMiddlewareCont2 = _slicedToArray(_createMiddlewareCont, 2),
      mwContextApi = _createMiddlewareCont2[0],
      updateMwContextApi = _createMiddlewareCont2[1];
    let paymentError;
    let paymentContextApi;
    try {
      logger.info("Payment start: PC:".concat(mwContextApi.payment.count(), " C:").concat(mwContextApi.payment.getTotalPrice()));
      isPendingPayment = true;
      observers.onStart.publish();
      await preMiddlewares.execute(mwContextApi);
      paymentContextApi = createPaymentContextApi(mwContextApi);
      const _await$paymentService = await paymentService.initiatePaymentRequest(paymentContextApi.createPaymentsIterable()),
        _await$paymentService2 = _slicedToArray(_await$paymentService, 2),
        paymentResults = _await$paymentService2[0],
        _paymentError = _await$paymentService2[1];

      paymentContextApi.mergeCollectionError(_paymentError);
      paymentError = paymentContextApi.getPaymentError();
      paymentContextApi.addPaidItems(paymentResults);
      const successfulPayableItemsCount = paymentContextApi.getPaidPayableItems().length;
      updateMwContextApi.payment.setPaidCount(successfulPayableItemsCount);
    } catch (error) {
      paymentError = error;
    } finally {
      paymentContextApi = paymentContextApi || createPaymentContextApi(mwContextApi);
      if (paymentError instanceof PaymentError) {
        logger.info("Payment exited: ".concat(paymentError));
      } else if (paymentError && !(paymentError instanceof CollectionError)) {
        logger.warn("Unhandled exception: ".concat(paymentError.message));
      }
      const totalPayableItems = payableItems.length;
      const successfulPayableItems = paymentContextApi.getPaidPayableItems().length;
      if (successfulPayableItems) {
        logger.info("Payment done: ".concat(successfulPayableItems, "(").concat(totalPayableItems, ")"));
      }
      paymentService.onPaymentDone(paymentContextApi.getPaidPayableItemsData());

      setTimeout(() => {
        paymentService.trackPayments(paymentContextApi.getPaidPayableItemsData(), userContext);
      });
      isPendingPayment = false;
    }
    const response = [createPaymentResponseApi(paymentService, paymentContextApi), paymentError];
    updateMwContextApi.payment.updatePaymentResponse(response);
    try {
      postMiddlewares.execute(mwContextApi);
    } catch (err) {
      logger.warn("Post middleware failed msg: ".concat(err === null || err === void 0 ? void 0 : err.message, ", ").concat(err));
    }
    observers.onFinally.publish(...response);
    return response;
  };

  obj.execute = function () {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$userContext = _ref.userContext,
      userContext = _ref$userContext === void 0 ? {} : _ref$userContext;
    isPaymentInitializedOnce = true;
    if (isPendingPayment) {
      logger.info('Payment already initialized');
      return proxyObj;
    }
    if (!payableItems.length) {
      throw new PaymentError({
        clientCode: PaymentError.ClientErrorCodes.NOT_ENOUGH_DATA
      });
    }

    return tryPay(userContext);
  };

  obj.addPreMiddleware = function () {
    preMiddlewares.push(...arguments);
    return proxyObj;
  };

  obj.addPostMiddleware = function () {
    postMiddlewares.push(...arguments);
    return proxyObj;
  };

  obj.addPayable = function () {
    paymentService.assertPayable(...arguments);
    payableItems.push(...arguments);
    return proxyObj;
  };
  proxyObj = new Proxy(obj, {
    set() {},
    get(target, prop) {
      if (isPaymentInitializedOnce && ['addPreMiddleware', 'addPostMiddleware'].includes(prop)) {
        throw new Error('Not allowed to add middleware after payment initialization');
      }
      return Reflect.get(...arguments);
    }
  });
  return proxyObj;
};
setGlobal('svs.components.payment.payment.createPayment', createPayment);

 })(window);